import { render, staticRenderFns } from "./ProductText.vue?vue&type=template&id=d09f115e&scoped=true&"
import script from "./ProductText.vue?vue&type=script&lang=js&"
export * from "./ProductText.vue?vue&type=script&lang=js&"
import style0 from "./ProductText.vue?vue&type=style&index=0&id=d09f115e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09f115e",
  null
  
)

export default component.exports